import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import Dashboard from "./views/Dahboard"; 
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/CropRecommendation";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/FertilizerRecommendation";
import Tables from "./views/Tables";
import BlogPosts from "./views/Analysis";
import Visualisation from "./views/Visualisation";

import Test from "./views/Test";
import soyaAnalysis from "./views/soyaAnalysis";
import management_practices from "./views/managementPractice";
import weatherPrediction from "./views/weatherPrediction";
import Reports from "./views/Reports";
import DiseaseDetection from "./views/DiseaseDetection";
import SeedDetection from "./views/SeedDetection";
import YieldPrediction from "./views/YieldPrediction";
import SoilTestAnalyzer from "./views/SoilTestAnalyzer";
import soilTypeDetector from "./views/soilTypeDetector";
import FeedBackSummary from "./views/FeedBackSummary";
import soilDataAnalysis from "./views/soilDataAnalysis";
import NutrientCalculator from "./views/NutrientCalculator";
import Login from "./views/Login";
import Profile from "./views/Profile";
import UserManagement from "./views/UserManagement";
import SoilTesting from "./views/SoilTesting";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => {
      const userRole = localStorage.getItem("userRole");

      // Define role-based redirections
      const roleRedirects = {
        user: "/home",
        Admin: "/home",
        superAdmin: "/home",
        Expert: "/feedback/summary"
      };
  
      return <Redirect to={roleRedirects[userRole] || "/login"} />;
    },
    roles: ["user", "Admin", "superAdmin", "Expert"]
  },
  {
    path: "/home",
    layout: DefaultLayout,
    component: Test,
    roles: ["user", "Admin","superAdmin"]
  },
  {
    path: "/soil-testing",
    layout: DefaultLayout,
    component: SoilTesting,
    roles: ["user", "Admin","superAdmin"]
  },

  // {
  //   path: "/user-profile-lite",
  //   layout: DefaultLayout,
  //   component: UserProfileLite
  // },
  {
    path: "/crop-recommendation",
    layout: DefaultLayout,
    component: AddNewPost,
    roles: ["Admin", "superAdmin"]
  },
  {
    path: "/agri/soil/data/analysis",
    layout: DefaultLayout,
    component: soilDataAnalysis,
    roles: ["Admin", "superAdmin"]
    
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors,
    roles: ["user", "Admin","superAdmin","Expert"]

  },
  {
    path: "/fertilizer-recommendation",
    layout: DefaultLayout,
    component: ComponentsOverview,
    roles: ["user","Expert", "Admin", "superAdmin"]

  },

  // {
  //   path: "/tables",
  //   layout: DefaultLayout,
  //   component: BlogOverview
  // },
  {
    path: "/analysis",
    layout: DefaultLayout,
    component: BlogPosts,
    roles: ["Admin", "superAdmin"]

  },
  {
    path: "/visualisation",
    layout: DefaultLayout,
    component: Visualisation,
    roles: ["Admin", "superAdmin"]

  },
    {
      path: "/soya",
      layout: DefaultLayout,
      component: soyaAnalysis,
      roles: ["Admin", "superAdmin"]

    },
    {
      path: "/management_practices",
      layout: DefaultLayout,
      component: management_practices,
      roles: [ "Admin", "superAdmin"]
    },
    // {
    //   path: "/weather-prediction",
    //   layout: DefaultLayout,
    //   component: weatherPrediction,
    //   roles: ["Admin", "superAdmin"]
    // },
    {
      path: "/soil/type/detector",
      layout: DefaultLayout,
      component: soilTypeDetector,
      roles: [ "Admin", "superAdmin"]
    },
    {
      path: "/feedback/summary",
      layout: DefaultLayout,
      component: FeedBackSummary,
      roles: ["Expert", "Admin","superAdmin"]
    },
    // {
    //   path: "/reports",
    //   layout: DefaultLayout,
    //   component: Reports,
    //   roles: [ "Admin", "superAdmin"]
    // },
    {
      path: "/disease-detection",
      layout: DefaultLayout,
      component: DiseaseDetection,
      roles: [ "Admin", "superAdmin"]
    },
    {
      path: "/seeds/detection",
      layout: DefaultLayout,
      component: SeedDetection,
      roles: [ "Admin", "superAdmin"]
    },
    {
      path: "/yield-prediction",
      layout: DefaultLayout,
      component: YieldPrediction,
      roles: [ "Admin", "superAdmin"]
    },
    {
      path: "/soil/test/analyzer",
      layout: DefaultLayout,
      component: SoilTestAnalyzer,
      roles: [ "Admin", "superAdmin"]
    },
    {
      path: "/soil/nutrient/calculator",
      layout: DefaultLayout,
      component: NutrientCalculator,
      roles: [ "Admin", "superAdmin"]
    },
    {
      path: "/profile",
      layout: DefaultLayout,
      component: Profile,
      roles: ["Expert"]
    },
    // {
    //   path: "/user_management",
    //   layout: DefaultLayout,
    //   component: UserManagement,
    //   roles: ["Admin", "superAdmin"]
    // },
    {
      path: "*",
      layout: DefaultLayout,
      component: () => <Redirect to="/" />,
      roles: ["user", "Admin","superAdmin","Expert"]
    },
];

